<template>
  <div>
    <v-container>
      <h1>Agreements Demo</h1>
    </v-container>
    <v-container class="agreements fill-height pt-5">
      <v-row class="center d-flex flex-column">
        <v-col md="4">
          <v-card class="d-flex flex-column">
            <v-card-title class="text-h5">
              Simple Agreement
            </v-card-title>

            <v-card-subtitle>
              Simple Agreement which asks user to agree and stores info in the
              database.
            </v-card-subtitle>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-dialog v-model="simpleDialog.show" persistent max-width="550">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#385F73" v-bind="attrs" v-on="on" dark>
                    Simple Agreement
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Team Member Agreement?
                  </v-card-title>
                  <v-card-text>
                    <div class="row mt-1">
                      Each Athlete, Coach, Sport Team Leader, Athlete, Support
                      Personnel, CPC Staff or Support / Mission Staff, Volunteer
                      and/or Contractor must agree to the Team Member Agreeemnt
                      to access the NCP Connect App
                    </div>

                    <v-row>
                      <div class="col pb-0 text-center">
                        <a :href="tma_en" target="_blank"
                          ><v-btn text>Agreement (EN) </v-btn></a
                        >
                      </div>
                      <div class="col pb-0 text-center">
                        <a :href="tma_fr" target="_blank"
                          ><v-btn text>
                            Agreement (FR)
                          </v-btn></a
                        >
                      </div>
                      <div class="col-12 text-center pt-0">
                        Click to View Agreement
                      </div>
                    </v-row>

                    <v-checkbox
                      v-if="simpleDialog.show"
                      v-model="simpleDialog.checkbox"
                      :rules="[(v) => !!v]"
                      required
                    >
                      <div slot="label">
                        I have read and agree to the <wbr /> Team Member
                        Agreement.
                      </div>
                    </v-checkbox>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="simpleDialog.show = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :dark="simpleDialog.checkbox"
                      color="green darken-1"
                      @click="simpleDialog.show = false"
                      :disabled="!simpleDialog.checkbox"
                    >
                      I Agree
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col md="4">
          <v-card class="d-flex flex-column">
            <v-card-title class="text-h5">
              Download Agreement
            </v-card-title>

            <v-card-subtitle>
              Where user is asked to download sign agreement then to scan / take
              a photo of signed version and upload to user profile.
            </v-card-subtitle>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-dialog
                v-model="downloadDialog.show"
                persistent
                max-width="550"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#385F73" v-bind="attrs" v-on="on" dark>
                    Download Agreement
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    IPC Conditions of Participation Agreement
                  </v-card-title>
                  <v-card-text>
                    <div class="row mt-1">
                      Each Athlete, Coach, Sport Team Leader, Athlete, Support
                      Personnel, CPC Staff or Support / Mission Staff, Volunteer
                      and/or Contractor must agree to the Team Member Agreeemnt
                      to access the NCP Connect App
                    </div>

                    <v-row>
                      <div class="col-6 text-center">
                        <v-btn
                          :text="downloadDialog.downloaded == true"
                          class="px-2"
                          @click.prevent="
                            downloadItem({
                              url: ipc_agreement,
                              label: 'IPC_Agreement',
                            })
                          "
                          >Download Agreement</v-btn
                        >
                      </div>
                      <div class="col-6 text-center">
                        <app-file-upload
                          :disabled="uploadDisabled"
                          text="Upload Signed Agreement"
                          @callback="simpleDialog.checkbox = true"
                        >
                        </app-file-upload>
                      </div>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="downloadDialog.show = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :dark="simpleDialog.checkbox"
                      color="green darken-1"
                      @click="downloadDialog.show = false"
                      :disabled="!simpleDialog.checkbox"
                    >
                      Complete
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AgreementsDemo",
  route: {
    path: "/agreements-demo",
    name: "Agreements",
  },
  components: {
    AppFileUpload: () => import("./components/AppFileUpload.vue"),
  },
  data() {
    return {
      tma_en: require("../../assets/agreements/TK20-AGR-CPTMemberAgreement-EN.pdf"),
      tma_fr: require("../../assets/agreements/TK20-AGR-CPTMemberAgreement-FR.pdf"),
      ipc_agreement: require("../../assets/agreements/TK20_GOV_IPC_Conditions_of_Participation_Agreement_EN.pdf"),
      simpleDialog: {
        show: false,
        checkbox: null,
      },
      downloadDialog: {
        show: false,
        checkbox: null,
        downloaded: false,
      },
      uploadDisabled: true,
    };
  },
  watch: {
    "simpleDialog.show": {
      handler() {
        this.simpleDialog.checkbox = null;
      },
    },
  },
  methods: {
    download(url) {
      window.open(url);
    },
    downloadItem({ url, label }) {
      this.uploadDisabled = false;

      // ADD USERS NAME TO FILE DOWNLOAD NAME
      if (this.$app.user.FullName) {
        label = this.$app.user.FullName.replace(" ", "_") + `-${label}`;
      }
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    downloadComplete() {
      this.downloadDialog;
    },
  },
};
</script>

<style></style>
